ui-cms-accordion-group {
  display: block;

  // This has to be added because we have an additional cms-wrapper for the sd-accordion
  // Therefore the sd-accordion style is not working
  ui-cms-accordion:not(:first-of-type) {
    sd-accordion {
      margin-top: -1px;
    }
  }
}
